import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "px-2",
  style: {"max-height":"calc(100vh - 3rem)","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_2 = { class: "d-flex align-items-start justify-content-between mb-3" }
const _hoisted_3 = { class: "pe-3" }
const _hoisted_4 = {
  class: "fs-4 umt-drawer-title text-gray-900",
  style: {"font-weight":"700"}
}
const _hoisted_5 = { class: "text-muted fs-7" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "text-gray-700" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-gray-700" }
const _hoisted_10 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_11 = { class: "d-flex flex-wrap gap-2 mb-4" }
const _hoisted_12 = {
  key: 0,
  class: "badge badge-light-info"
}
const _hoisted_13 = { class: "fs-8 text-gray-800 mb-1" }
const _hoisted_14 = { class: "table-responsive ms-3" }
const _hoisted_15 = { class: "table table-row-dashed align-middle fs-8 mb-1" }
const _hoisted_16 = { class: "text-muted" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { class: "p-1" }, "Môn", -1)
const _hoisted_18 = {
  key: 0,
  class: "p-1"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { class: "p-1" }, "Bộ GD&ĐT", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", { class: "p-1" }, "Hệ thống", -1)
const _hoisted_21 = { class: "p-1 text-gray-800 text-nowrap" }
const _hoisted_22 = {
  key: 0,
  class: "p-1 text-gray-600 text-nowrap"
}
const _hoisted_23 = { class: "p-1 fw-bolder text-gray-900" }
const _hoisted_24 = { class: "ms-3" }
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-down-circle me-1" }, null, -1)
const _hoisted_27 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_28 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary" }, "Tiếp nhận hồ sơ & thanh toán", -1)
const _hoisted_30 = { class: "row g-3" }
const _hoisted_31 = { class: "col-12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tình trạng tiếp nhận hồ sơ", -1)
const _hoisted_33 = { class: "col-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tổng tiền", -1)
const _hoisted_35 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_36 = { class: "col-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Đã thanh toán", -1)
const _hoisted_38 = { class: "text-success fw-bolder fs-7" }
const _hoisted_39 = { class: "col-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Còn lại", -1)
const _hoisted_41 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_42 = { class: "col-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Hình thức thanh toán", -1)
const _hoisted_44 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_45 = { class: "col-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Học bổng", -1)
const _hoisted_47 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_48 = { class: "col-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phụ trách", -1)
const _hoisted_50 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_51 = { class: "col-4" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày tạo", -1)
const _hoisted_53 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_54 = { class: "col-4" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Cập nhật", -1)
const _hoisted_56 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_57 = { class: "col-4" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Người sửa cuối", -1)
const _hoisted_59 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_60 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_61 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary" }, "Thông tin cá nhân", -1)
const _hoisted_63 = { class: "row g-3" }
const _hoisted_64 = { class: "col-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "MSSV", -1)
const _hoisted_66 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_67 = { class: "col-4" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày sinh", -1)
const _hoisted_69 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_70 = { class: "col-4" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Số điện thoại", -1)
const _hoisted_72 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_73 = { class: "col-12" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Email liên hệ", -1)
const _hoisted_75 = { class: "text-gray-900 fw-bolder fs-7 text-break" }
const _hoisted_76 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_77 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary" }, "Hồ sơ nhập học", -1)
const _hoisted_79 = { class: "row g-3" }
const _hoisted_80 = { class: "col-8" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngành trúng tuyển", -1)
const _hoisted_82 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_83 = { class: "col-4" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Mã hồ sơ", -1)
const _hoisted_85 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_86 = { class: "col-4" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Chương trình", -1)
const _hoisted_88 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_89 = { class: "col-4" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Đợt", -1)
const _hoisted_91 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_92 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_93 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary" }, "Thông tin nhập học", -1)
const _hoisted_95 = { class: "row g-3" }
const _hoisted_96 = { class: "col-4" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày sinh", -1)
const _hoisted_98 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_99 = { class: "col-4" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Giới tính", -1)
const _hoisted_101 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_102 = { class: "col-4" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Nơi sinh", -1)
const _hoisted_104 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_105 = { class: "col-4" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "CCCD", -1)
const _hoisted_107 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_108 = { class: "col-4" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày cấp", -1)
const _hoisted_110 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_111 = { class: "col-4" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Nơi cấp", -1)
const _hoisted_113 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_114 = { class: "col-4" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Dân tộc", -1)
const _hoisted_116 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_117 = { class: "col-4" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tôn giáo", -1)
const _hoisted_119 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_120 = { class: "col-4" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Quốc tịch", -1)
const _hoisted_122 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_123 = { class: "col-4" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Số điện thoại", -1)
const _hoisted_125 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_126 = { class: "col-8" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Email liên hệ", -1)
const _hoisted_128 = { class: "text-gray-900 fw-bolder fs-7 text-break" }
const _hoisted_129 = { class: "col-4" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Địa chỉ liên lạc", -1)
const _hoisted_131 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_132 = { class: "col-4" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phường/Xã", -1)
const _hoisted_134 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_135 = { class: "col-4" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tỉnh/TP", -1)
const _hoisted_137 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_138 = { class: "col-4" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Địa chỉ thường trú", -1)
const _hoisted_140 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_141 = { class: "col-4" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phường/Xã", -1)
const _hoisted_143 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_144 = { class: "col-4" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tỉnh/TP", -1)
const _hoisted_146 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_147 = { class: "col-8" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Trường THPT", -1)
const _hoisted_149 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_150 = { class: "col-4" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Năm tốt nghiệp", -1)
const _hoisted_152 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_153 = { class: "col-4" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "MSSV", -1)
const _hoisted_155 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_156 = { class: "col-4" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Loại chương trình", -1)
const _hoisted_158 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_159 = { class: "col-4" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Nguồn", -1)
const _hoisted_161 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_162 = { class: "col-12" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Email sinh viên", -1)
const _hoisted_164 = { class: "text-gray-900 fw-bolder fs-7 text-break" }
const _hoisted_165 = { class: "col-4" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tiếp nhận hồ sơ", -1)
const _hoisted_167 = { class: "col-4" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phí giữ suất", -1)
const _hoisted_169 = {
  key: 0,
  class: "text-gray-500 fs-7"
}
const _hoisted_170 = { class: "col-4" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Học phí", -1)
const _hoisted_172 = {
  key: 0,
  class: "text-gray-500 fs-7"
}
const _hoisted_173 = { class: "col-4" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Đã thanh toán", -1)
const _hoisted_175 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_176 = { class: "col-4" }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Còn lại", -1)
const _hoisted_178 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_179 = { class: "col-4" }
const _hoisted_180 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Học bổng", -1)
const _hoisted_181 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_182 = { class: "col-4" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Hỗ trợ tài chính", -1)
const _hoisted_184 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_185 = { class: "col-4" }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Thanh toán", -1)
const _hoisted_187 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_188 = { class: "col-4" }
const _hoisted_189 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tiếng Anh xếp lớp", -1)
const _hoisted_190 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_191 = { class: "col-4" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phụ trách", -1)
const _hoisted_193 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_194 = { class: "col-4" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Người sửa cuối", -1)
const _hoisted_196 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_197 = { class: "col-4" }
const _hoisted_198 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày tạo", -1)
const _hoisted_199 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_200 = { class: "col-4" }
const _hoisted_201 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Cập nhật", -1)
const _hoisted_202 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_203 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_204 = { class: "d-flex align-items-center justify-content-between mb-3" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary" }, "Thông tin trúng tuyển", -1)
const _hoisted_206 = { class: "row g-3" }
const _hoisted_207 = { class: "col-8" }
const _hoisted_208 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngành trúng tuyển", -1)
const _hoisted_209 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_210 = { class: "col-4" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Mã hồ sơ", -1)
const _hoisted_212 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_213 = { class: "col-4" }
const _hoisted_214 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Điểm trúng tuyển", -1)
const _hoisted_215 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_216 = { class: "col-4" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phương thức", -1)
const _hoisted_218 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_219 = { class: "col-4" }
const _hoisted_220 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Đợt", -1)
const _hoisted_221 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_222 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4 d-flex align-items-center justify-content-between" }
const _hoisted_223 = /*#__PURE__*/_createElementVNode("div", { class: "pe-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary" }, "Thông tin cá nhân (ứng viên)"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8" }, "Phần lớn trùng với thông tin nhập học — xem/sửa tại trang ứng viên")
], -1)
const _hoisted_224 = {
  key: 1,
  class: "text-muted fs-8 fst-italic text-nowrap",
  title: "Hồ sơ không thuộc phụ trách của bạn"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_sync_info_banner = _resolveComponent("sync-info-banner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    direction: "rtl",
    size: "500px",
    "with-header": false,
    "append-to-body": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.row)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.row.fullName), 1),
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.row.idNumber)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createTextVNode("CCCD: "),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.row.idNumber), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.row.code)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                          _createTextVNode(" · Mã HS: "),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.row.code), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("span", {
                  class: "btn btn-sm btn-icon btn-active-light-primary",
                  title: "Đóng",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false))
                }, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", {
                  class: _normalizeClass(`badge badge-light-${_ctx.statusTag[_ctx.row.status]?.state}`)
                }, _toDisplayString(_ctx.statusTag[_ctx.row.status]?.label), 3),
                (_ctx.row.scholarshipCode)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Học bổng " + _toDisplayString(_ctx.row.scholarshipCode), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.showSyncCheck)
                ? (_openBlock(), _createBlock(_component_sync_info_banner, {
                    key: 0,
                    "applicant-id": _ctx.row.id,
                    onSynced: _ctx.onSynced
                  }, null, 8, ["applicant-id", "onSynced"]))
                : _createCommentVNode("", true),
              (_ctx.showSyncCheck && _ctx.bgdRes)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["rounded p-3 mb-4 border", _ctx.bgdRes.mismatches.length ? 'border-danger bg-light-danger' : (_ctx.bgdRes.hasData ? 'border-success bg-light-success' : 'border-gray-300 bg-light')])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["d-flex align-items-center fs-7 fw-bolder mb-1", _ctx.bgdRes.mismatches.length ? 'text-danger' : (_ctx.bgdRes.hasData ? 'text-success' : 'text-gray-700')])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["bi me-2", _ctx.bgdRes.mismatches.length ? 'bi-exclamation-octagon-fill' : (_ctx.bgdRes.hasData ? 'bi-patch-check-fill' : 'bi-dash-circle')])
                      }, null, 2),
                      _createTextVNode(" " + _toDisplayString(_ctx.bgdRes.mismatches.length ? 'LỆCH với dữ liệu Bộ GD&ĐT — chuyển giao SIS sẽ bị chặn' : (_ctx.bgdRes.hasData ? 'Khớp dữ liệu Bộ GD&ĐT' : 'Chưa có dữ liệu Bộ để đối chiếu')), 1)
                    ], 2),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherMismatches, (m, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'bm' + i,
                        class: "fs-8 text-gray-800"
                      }, "• " + _toDisplayString(m), 1))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.bgdRes.scoreDiffs || []), (d, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'bs' + i,
                        class: "mt-2"
                      }, [
                        _createElementVNode("div", _hoisted_13, "• " + _toDisplayString(d.text), 1),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("table", _hoisted_15, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_16, [
                                _hoisted_17,
                                (d.type === 'transcript')
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_18, "Lớp"))
                                  : _createCommentVNode("", true),
                                _hoisted_19,
                                _hoisted_20
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.cells, (c, j) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: 'bc' + i + '-' + j
                                }, [
                                  _createElementVNode("td", _hoisted_21, _toDisplayString(c.mon), 1),
                                  (d.type === 'transcript')
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_22, _toDisplayString(c.lop), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", _hoisted_23, _toDisplayString(c.bo), 1),
                                  _createElementVNode("td", {
                                    class: _normalizeClass(["p-1", c.he === null ? 'text-gray-500 fst-italic' : 'text-danger fw-bolder'])
                                  }, _toDisplayString(c.he === null ? 'trống' : c.he), 3)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives((_openBlock(), _createElementBlock("button", {
                            type: "button",
                            class: "btn btn-sm btn-light-danger py-1 px-3 fs-8",
                            disabled: _ctx.bgdApplying,
                            onClick: ($event: any) => (_ctx.applyBgdScores(d)),
                            title: "Ghi điểm của Bộ đè lên điểm đang lưu của ứng viên"
                          }, [
                            _hoisted_26,
                            _createTextVNode(_toDisplayString(_ctx.bgdApplying ? 'Đang cập nhật…' : 'Cập nhật theo điểm Bộ'), 1)
                          ], 8, _hoisted_25)), [
                            [_directive_permission, [_ctx.Permission.STUDENT_BGD_APPLY, _ctx.Permission.STUDENT]]
                          ])
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bgdRes.notes, (n, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'bn' + i,
                        class: "fs-8 text-gray-600 fst-italic"
                      }, _toDisplayString(n), 1))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.receptionFocus)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createVNode(_component_router_link, {
                          to: { path: `/danhsachthutucnhaphoc/${_ctx.row.id}`, hash: '#phieutiepnhan' },
                          class: "fs-8",
                          title: "Mở tab Phiếu tiếp nhận hồ sơ"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Phiếu tiếp nhận ↗")
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.row.isApplicationFormPrinted ? 'text-success fw-bolder fs-7' : 'text-gray-500 fs-7')
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(_ctx.row.isApplicationFormPrinted ? 'bi bi-check-circle-fill me-1' : 'bi bi-dash-circle me-1')
                            }, null, 2),
                            _createTextVNode(_toDisplayString(_ctx.row.isApplicationFormPrinted ? 'Đã tiếp nhận' : 'Chưa tiếp nhận'), 1)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.money((+_ctx.row.totalpaid||0)+(+_ctx.row.totalremaining||0))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.money(_ctx.row.totalpaid)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.money(_ctx.row.totalremaining)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.payLabel(_ctx.row.orderDetails?.paymentMethod)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.row.scholarshipCode || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.assigneeLabel(_ctx.row) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.row.createdAtFormat || _ctx.moment(_ctx.row.createdAt) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _hoisted_55,
                          _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.row.updatedAtFormat || _ctx.moment(_ctx.row.updatedAt) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _hoisted_58,
                          _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.row.lastModifiedBy ? String(_ctx.row.lastModifiedBy).split('_')[0] : '—'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        (_ctx.row.studentId && _ctx.canViewDetail)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/danhsachungvien/${_ctx.row.studentId}`,
                              class: "fs-8",
                              title: "Mở trang Thông tin chi tiết ứng viên"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Thông tin ứng viên ↗")
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.row.studentCode || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.moment(_ctx.row.dateOfBirth) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_70, [
                          _hoisted_71,
                          _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.row.contactMobile || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_73, [
                          _hoisted_74,
                          _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.row.contactEmail || '—'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        (_ctx.row.admissionRegistration?.idAdReg && _ctx.canViewDetail)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/hosoungvien/${_ctx.row.admissionRegistration.idAdReg}`,
                              class: "fs-8",
                              title: "Mở chi tiết hồ sơ xét tuyển"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Chi tiết hồ sơ ↗")
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _hoisted_81,
                          _createElementVNode("div", _hoisted_82, _toDisplayString(_ctx.row.admissionRegistration?.adMajorName || _ctx.row.major || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _hoisted_84,
                          _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.row.code || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _hoisted_87,
                          _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.programtypeLabel(_ctx.row.programtype) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.row.phase || '—'), 1)
                        ])
                      ])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createElementVNode("div", _hoisted_92, [
                      _createElementVNode("div", _hoisted_93, [
                        _hoisted_94,
                        _createVNode(_component_router_link, {
                          to: `/danhsachthutucnhaphoc/${_ctx.row.id}`,
                          class: "fs-8",
                          title: "Mở trang chi tiết / chỉnh sửa phiếu nhập học"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Trang chi tiết ↗")
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _createElementVNode("div", _hoisted_96, [
                          _hoisted_97,
                          _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.moment(_ctx.row.dateOfBirth) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          _hoisted_100,
                          _createElementVNode("div", _hoisted_101, _toDisplayString(_ctx.genderLabel(_ctx.row.gender) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _hoisted_103,
                          _createElementVNode("div", _hoisted_104, _toDisplayString(_ctx.row.placeOfBirth || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_105, [
                          _hoisted_106,
                          _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.row.idNumber || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_108, [
                          _hoisted_109,
                          _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.moment(_ctx.row.issuedDate) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_111, [
                          _hoisted_112,
                          _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.row.issuedBy || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_114, [
                          _hoisted_115,
                          _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.row.ethnic || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_117, [
                          _hoisted_118,
                          _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.row.religion || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_120, [
                          _hoisted_121,
                          _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.row.nationality || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_123, [
                          _hoisted_124,
                          _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.row.contactMobile || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_126, [
                          _hoisted_127,
                          _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.row.contactEmail || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_129, [
                          _hoisted_130,
                          _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.row.postalAddress || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_132, [
                          _hoisted_133,
                          _createElementVNode("div", _hoisted_134, _toDisplayString([_ctx.row.postalWard, _ctx.row.postalDistrict].filter(Boolean).join(', ') || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_135, [
                          _hoisted_136,
                          _createElementVNode("div", _hoisted_137, _toDisplayString(_ctx.row.postalProvince || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_138, [
                          _hoisted_139,
                          _createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.row.permanentAddress || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_141, [
                          _hoisted_142,
                          _createElementVNode("div", _hoisted_143, _toDisplayString([_ctx.row.permanentWard, _ctx.row.permanentDistrict].filter(Boolean).join(', ') || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_144, [
                          _hoisted_145,
                          _createElementVNode("div", _hoisted_146, _toDisplayString(_ctx.row.permanentProvince || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_147, [
                          _hoisted_148,
                          _createElementVNode("div", _hoisted_149, _toDisplayString(_ctx.row.highschoolName || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_150, [
                          _hoisted_151,
                          _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.row.yearOfGraduation || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_153, [
                          _hoisted_154,
                          _createElementVNode("div", _hoisted_155, _toDisplayString(_ctx.row.studentCode || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_156, [
                          _hoisted_157,
                          _createElementVNode("div", _hoisted_158, _toDisplayString(_ctx.programtypeLabel(_ctx.row.programtype) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_159, [
                          _hoisted_160,
                          _createElementVNode("div", _hoisted_161, _toDisplayString(_ctx.row.source || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_162, [
                          _hoisted_163,
                          _createElementVNode("div", _hoisted_164, _toDisplayString(_ctx.row.email || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_165, [
                          _hoisted_166,
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.row.isApplicationFormPrinted ? 'text-success fw-bolder fs-7' : 'text-gray-500 fs-7')
                          }, _toDisplayString(_ctx.row.isApplicationFormPrinted ? 'Đã tiếp nhận' : 'Chưa'), 3)
                        ]),
                        _createElementVNode("div", _hoisted_167, [
                          _hoisted_168,
                          (_ctx.noReceiptInfo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_169, "—"))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(_ctx.row.isDeposit ? 'text-success fw-bolder fs-7' : 'text-gray-500 fs-7')
                              }, _toDisplayString(_ctx.row.isDeposit ? 'Đã đóng' : 'Chưa'), 3))
                        ]),
                        _createElementVNode("div", _hoisted_170, [
                          _hoisted_171,
                          (_ctx.noReceiptInfo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_172, "—"))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: _normalizeClass(_ctx.row.isTuition ? 'text-success fw-bolder fs-7' : 'text-gray-500 fs-7')
                              }, _toDisplayString(_ctx.row.isTuition ? 'Đã đóng' : 'Chưa'), 3))
                        ]),
                        _createElementVNode("div", _hoisted_173, [
                          _hoisted_174,
                          _createElementVNode("div", _hoisted_175, _toDisplayString(_ctx.money(_ctx.row.totalpaid)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_176, [
                          _hoisted_177,
                          _createElementVNode("div", _hoisted_178, _toDisplayString(_ctx.money(_ctx.row.totalremaining)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_179, [
                          _hoisted_180,
                          _createElementVNode("div", _hoisted_181, _toDisplayString(_ctx.row.scholarshipCode || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_182, [
                          _hoisted_183,
                          _createElementVNode("div", _hoisted_184, _toDisplayString(_ctx.row.financialSupportRegistration?.isFinancialSupport ? 'Có đăng ký' : '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_185, [
                          _hoisted_186,
                          _createElementVNode("div", _hoisted_187, _toDisplayString(_ctx.payLabel(_ctx.row.orderDetails?.paymentMethod)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_188, [
                          _hoisted_189,
                          _createElementVNode("div", _hoisted_190, _toDisplayString(_ctx.englishLabel(_ctx.row.englishClassPlacementTestRegistration?.registrationType)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_191, [
                          _hoisted_192,
                          _createElementVNode("div", _hoisted_193, _toDisplayString(_ctx.assigneeLabel(_ctx.row) || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_194, [
                          _hoisted_195,
                          _createElementVNode("div", _hoisted_196, _toDisplayString(_ctx.row.lastModifiedBy ? String(_ctx.row.lastModifiedBy).split('_')[0] : '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_197, [
                          _hoisted_198,
                          _createElementVNode("div", _hoisted_199, _toDisplayString(_ctx.row.createdAtFormat || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_200, [
                          _hoisted_201,
                          _createElementVNode("div", _hoisted_202, _toDisplayString(_ctx.row.updatedAtFormat || '—'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_203, [
                      _createElementVNode("div", _hoisted_204, [
                        _hoisted_205,
                        (_ctx.row.admissionRegistration?.idAdReg && _ctx.canViewDetail)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/hosoungvien/${_ctx.row.admissionRegistration.idAdReg}`,
                              class: "fs-8",
                              title: "Mở chi tiết hồ sơ xét tuyển"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Chi tiết hồ sơ ↗")
                              ]),
                              _: 1
                            }, 8, ["to"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_206, [
                        _createElementVNode("div", _hoisted_207, [
                          _hoisted_208,
                          _createElementVNode("div", _hoisted_209, _toDisplayString(_ctx.row.admissionRegistration?.adMajorName || _ctx.row.major || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_210, [
                          _hoisted_211,
                          _createElementVNode("div", _hoisted_212, _toDisplayString(_ctx.row.code || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_213, [
                          _hoisted_214,
                          _createElementVNode("div", _hoisted_215, _toDisplayString(_ctx.scoreLabel(_ctx.row.averageScore)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_216, [
                          _hoisted_217,
                          _createElementVNode("div", _hoisted_218, _toDisplayString(_ctx.row.admissionRegistration?.adMethod || '—'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_219, [
                          _hoisted_220,
                          _createElementVNode("div", _hoisted_221, _toDisplayString(_ctx.row.phase || '—'), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_222, [
                      _hoisted_223,
                      (_ctx.row.studentId && _ctx.canViewDetail)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/danhsachungvien/${_ctx.row.studentId}`,
                            class: "fs-7 fw-bolder text-nowrap",
                            title: "Mở trang Thông tin chi tiết ứng viên"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Thông tin ứng viên ↗")
                            ]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_224, "Không thuộc phụ trách"))
                    ])
                  ], 64))
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}